import { useTitle } from "easy-page-router/react";
import { useHeaders } from "ssr-hook";
import moment from "moment";

export function useHead(title: string, description: string) {
    const titleWithPostFix = `${title} | Jilemnicko - společenství obcí`;
    useTitle(titleWithPostFix);
    useHeaders({
        title: titleWithPostFix,
        description,
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });
}

export async function toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || "");
        reader.onerror = reject;
    });
}

export function getFileName(fullName: string, fullUrl: string): string {
    const url = fullUrl.split(".");
    const ext = url[url.length - 1];

    if (fullName.endsWith(`.${ext}`)) return fullName;

    return `${fullName}.${ext}`;
}

export function validateEmail(email: string) {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}

export function getGoogleCalendarUrl(event: {
    title: string;
    text?: string;
    place?: string;
    dateFrom: string;
    dateTo?: string | null;
}) {
    const hasTime = event.dateFrom.includes("T");
    let dates: string;

    if (hasTime) {
        const start = moment(event.dateFrom).format("YYYYMMDDTHHmmss");
        const end = moment(event.dateTo || event.dateFrom).format("YYYYMMDDTHHmmss");
        dates = `${start}/${end}`;
    } else {
        const start = moment(event.dateFrom).format("YYYYMMDD");
        const end = moment(event.dateTo || event.dateFrom).add(1, "day").format("YYYYMMDD");
        dates = `${start}/${end}`;
    }

    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: event.title,
        dates,
        details: event.text || "",
        location: event.place || "",
    });

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
